var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3174a7",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M12.086 3v8.485m0 0L15.17 8.4m-3.085 3.085L9 8.4M4 21v-6.5a.5.5 0 0 1 .5-.5h2.78a1 1 0 0 1 .948.684l.658 1.974A.5.5 0 0 0 9.36 17h5.28a.5.5 0 0 0 .474-.342l.658-1.974a1 1 0 0 1 .949-.684H19.5a.5.5 0 0 1 .5.5V21a.5.5 0 0 1-.5.5h-15A.5.5 0 0 1 4 21Z"
  })));
};
export default SvgDownload;